<template>
  <div :class='showPropertyForm ? "" : ""'>
    <component v-if='condensedComponent' class="w-full" :is='condensedComponent' 
          :transform='transform'
          :transforms-and-source='transformsAndSource'
          :partutil='partutil'
          :component='component'
          :disable-icon='disableIcon'
          :show-property-form='showPropertyForm'
          />
    <div v-else>{{component.type}}</div>
  </div>
</template>
<script>
// This file is auto-generated
const CondensedComponents = {};
import tween from '@components/condensed/tweenCondensed.vue'
import generic from '@components/atoms/CondensedComponent.vue';

CondensedComponents["tween"] = tween
CondensedComponents["generic"] = generic
export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    partutil :{
      type: Object,
      required:true
    },
    disableIcon: {
      type: Boolean,
      required: false
    },
    showPropertyForm: {
      type: Boolean,
      default: true
    }
  },
  data() {
    let condensedComponent = CondensedComponents[this.component.type];
    if (!condensedComponent) {
      condensedComponent = CondensedComponents.generic;
    }
    return {
      condensedComponent
    }
  }
}
</script>
